export const MENSAGEM_LINK_EXPIRADO =
  "Link de redefinição de senha expirado ou já utilizado. Solicite uma nova recuperação de senha.";

const RETORNOS_SUCESSO = ["sucesso", "saved", "LOGGEDOUT"];

export interface InfoLinkTrocaSenha {
  expirado?: boolean | null;
  goLogin?: boolean | null;
}

export const linkTrocaSenhaValido = (info: InfoLinkTrocaSenha | null | undefined): boolean =>
  !!info && !info.expirado && !info.goLogin;

export const resultadoRedefinicaoSenha = (retorno: string | null | undefined) =>
  retorno && RETORNOS_SUCESSO.includes(retorno)
    ? { sucesso: true, mensagem: "Senha redefinida com sucesso." }
    : { sucesso: false, mensagem: MENSAGEM_LINK_EXPIRADO };
